<script setup>
/**
 * Popup edit overlay for inline editing of a value directly on a table cell or field.
 *
 * @status recommended
 * @group overlays
 * @useWhen Editing a data value in-place on a table row without opening a full form
 * @see https://quasar.dev/vue-components/popup-edit Quasar q-popup-edit API
 */
defineOptions({ name: 'HrPopupEdit' });
</script>

<template>
  <q-popup-edit
    v-slot="scope"
    v-bind="$attrs"
  >
    <!-- @slot Edit form content; receives the Quasar popup scope (initialValue, value, set, cancel, …). -->
    <slot v-bind="scope" />
  </q-popup-edit>
</template>
